import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const MagnifierSvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 33 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M15.0205 25.9574C20.8569 25.9574 25.5883 21.1548 25.5883 15.2304C25.5883 9.30605 20.8569 4.50342 15.0205 4.50342C9.18402 4.50342 4.45264 9.30605 4.45264 15.2304C4.45264 21.1548 9.18402 25.9574 15.0205 25.9574Z'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M28.2301 28.6394L22.4839 22.8066'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15.0205 11.208V19.2532'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.0576 15.2305H18.9835'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const MagnifierIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={MagnifierSvg} {...props} />
);
